export type TapeSampleProductType = keyof typeof TapeSampleProductTypes;

// eslint-disable-next-line no-shadow
export enum TapeSampleProductTypes {
  "tesa Product" = "TESA_PRODUCT",
  "tesa Prototype" = "TESA_PROTOTYPE",
  "Competitor Product" = "COMPETITOR_PRODUCT",
  "Unknown Product" = "UNKNOWN_PRODUCT",
}

export function labelOf(key: string | null): string {
  return (
    Object.keys(TapeSampleProductTypes)
      .map((k) => k as TapeSampleProductType)
      .filter((k) => TapeSampleProductTypes[k] === key)
      .pop() || ""
  );
}
